import Head from 'next/head'
import { WhitepaperArticleRecord } from 'types'

import { Footer } from '@/components/elements/footer/Footer'
import { Header } from '@/components/elements/header/Header'
import { ScienceSubNavigation } from '@/components/elements/science/ScienceSubNavigation'

import { WhitepaperArticleContent } from './Article/WhitepaperArticleContent'
import { WhitepaperArticleHeader } from './Article/WhitepaperArticleHeader'
import { WhitepaperArticleImage } from './Article/WhitepaperArticleImage'

type WhitepaperArticleProps = {
  article: WhitepaperArticleRecord
}

export const WhitepaperArticle: React.FC<WhitepaperArticleProps> = ({ article }) => {
  return (
    <>
      <Head>
        <title>{article.articleTitle}</title>
        <link rel="canonical" href={`${process.env.SITE_URL}/whitepapers/${article.articleSlug}`} />
      </Head>

      <Header backgroundColor="white" />

      <ScienceSubNavigation selected={`/whitepapers/${article.articleSlug}`} />

      <main id="main-content">
        <article aria-label={article.articleTitle}>
          <WhitepaperArticleHeader article={article}></WhitepaperArticleHeader>
          <WhitepaperArticleImage article={article}></WhitepaperArticleImage>
          <WhitepaperArticleContent article={article}></WhitepaperArticleContent>
        </article>
      </main>

      <Footer showPreFooter />
    </>
  )
}
